'use client';

import Icon from './Icon';
import svg from 'sprites/ru-store.svg';

export default function IconRuStore({
  className = 'w-4 h-4 fill-graphite stroke-none'
}: {
  className?: string;
}) {
  return <Icon id={svg.id} className={className} />;
}
